import { combineReducers } from 'redux';

/** IMPORT REDUCER */
import atendimentoPosto from './atendimentoPosto/reducer';
import operacaoradadmdadosfaturamentoseplag from './operacaoradadmdadosfaturamentoseplag/reducer';
import unidadeSaldoCota from './unidadeSaldoCota/reducer';
import saldoCotaOrgaoLista from './saldoCotaOrgaoLista/reducer';
import auditoriaParametros from './auditoriaParametros/reducer';
import perfil from './perfil/reducer';
import arqueacao from './arqueacao/reducer';
import auth from './auth/reducer';
import esqueciminhasenha from './esqueciminhasenha/reducer';
import operacaoabastecimento from './operacaoabastecimento/reducer';
import operacaoliberacaoremota from './operacaoliberacaoremota/reducer';
import operacaoprerecebimentolista from './operacaoprerecebimentolista/reducer';
import operacaonotafiscaldescargas from './operacaonotafiscaldescargas/reducer';
import operacaoconsultalogliberacaosiad from './operacaoconsultalogliberacaosiad/reducer';
import operacaoconsultaimpedimentos from './operacaoconsultaimpedimentos/reducer';
import operacaoextratodadoscapatnqpostos from './operacaoextratodadoscapatnqpostos/reducer';
import operacaopostocontrolesiad from './operacaopostocontrolesiad/reducer';
import operacaopostomanutencao from './operacaopostomanutencao/reducer';
import operacaopostomigragestoresfrentista from './operacaopostomigragestoresfrentista/reducer';
import operacaovazamento from './operacaovazamento/reducer';
import operacaooperstatusterminais from './operacaooperstatusterminais/reducer';
import operacaoprerecebimento from './operacaoprerecebimento/reducer';
import operacaoimpedimentos from './operacaoimpedimentos/reducer';
import operacaoradaprovarprefatura from './operacaoradaprovarprefatura/reducer';
import operacaoliberacaoremotaconsulta from './operacaoliberacaoremotaconsulta/reducer';
import operacaoradpesquisaprefaturagfo from './operacaoradpesquisaprefaturagfo/reducer';
import operacaoradpesquisaprefaturaunidata from './operacaoradpesquisaprefaturaunidata/reducer';
import operacaobloqueioveiculoprefaturas from './OperacaoBloqueioVeiculoPreFaturas/reducer';
import operacaobloqueioveiculoprefaturagerada from './OperacaoBloqueioVeiculoPreFaturaGerada/reducer';
import operacaobloqueioprefaturageradaitem from './operacaobloqueioprefaturageradaitem/reducer';
import cadastrousuariomaster from './cadastrousuariomaster/reducer';
import cadastrocondutor from './cadastrocondutor/reducer';
import cadastromarca from './cadastromarca/reducer';
import cadastroposto from './cadastroposto/reducer';
import cadastroterminal from './cadastroterminal/reducer';
import operacaoradadmdadosfaturamentounidata from './operacaoradadmdadosfaturamentounidata/reducer';
import organRegistration from './organRegistration/reducer';
import unityRegistration from './unityRegistration/reducer';
import vehicleRegistration from './vehicleRegistration/reducer';

import bico from './bico/reducer';
import centrocusto from './centrocusto/reducer';
import cercasvirtuais from './cercasVirtuais/reducer';
import comboio from './comboio/reducer';
import configuracaoalarmetanque from './configuracaoalarmetanque/reducer';
import contrato from './contrato/reducer';
import dialog from './dialog/reducer';
import drawer from './drawer/reducer';
import empresaveiculo from './empresaveiculo/reducer';
import estoqueproduto from './estoqueproduto/reducer';
import hooks from './hooks/reducer';
import language from './language/reducer';
import marcasveiculo from './marcasveiculo/reducer';
import medidor from './medidor/reducer';
import modeloveiculo from './modeloveiculo/reducer';
import motorista from './motorista/reducer';
import operacao from './operacao/reducer';

import operacaoestoqueposto from './operacaoestoqueposto/reducer';
import operacaoestoquetanque from './operacaoestoquetanque/reducer';
import operacaorecebimento from './operacaorecebimento/reducer';
import operacaotransferencia from './operacaotransferencia/reducer';
import operacaoafericaoveiculo from './operacaoafericaoveiculo/reducer';

import auditoria from './auditoria/reducer'
import auditoriaitem from './auditoriaItem/reducer'
import posto from './posto/reducer';
import produto from './produto/reducer';
import tanquefisico from './tanquefisico/reducer';
import tanquevirtual from './tanquevirtual/reducer';
import terminal from './terminal/reducer';
import user from './user/reducer';
import usuario from './usuario/reducer';
import veiculo from './veiculo/reducer';
import frentista from './frentista/reducer';
import orgao from './orgao/reducer';
import unidade from './unidade/reducer';
import postoplanejamento from './postoplanejamento/reducer';
import postoPlanejamentoGpp from './postoPlanejamentoGpp/reducer';
import rateio from './rateio/reducer'

import operacaoradrelatoriopesquisaprefaturaunidata from './operacaoradrelatoriopesquisaprefaturaunidata/reducer';

import operacaoradprefaturabloqueioplacarelatorio from './operacaoradprefaturabloqueioplacarelatorio/reducer';
import operacaoveiculomanutencaounidata from './operacaoveiculomanutencaounidata/reducer';
import pleitoposto from './pleitoposto/reducer'
import pleitoveiculo from './pleitoveiculo/reducer'
import operacaocotadistriborgao from './operacaocotadistriborgao/reducer'
import operacaocotadistribunidade from './operacaocotadistribunidade/reducer'
import operacaocotadistribveiculo from './operacaocotadistribveiculo/reducer'
import pleitoPostoAnexo from './pleitopostoanexo/reducer';
import limiteAbastecimento from './limiteAbastecimento/reducer'
import turnoAcompanhamento from './turnoAcompanhamento/reducer';

export default combineReducers({
  /** EXPORT REDUCER */
atendimentoPosto,
  operacaoradadmdadosfaturamentoseplag,
  unidadeSaldoCota,
  saldoCotaOrgaoLista,
  auditoriaParametros,
  perfil,
  auth,
  esqueciminhasenha,
  operacaoabastecimento,
  operacaoliberacaoremota,
  operacaoprerecebimentolista,
  operacaonotafiscaldescargas,
  operacaoconsultalogliberacaosiad,
  operacaoconsultaimpedimentos,
  operacaoextratodadoscapatnqpostos,
  operacaopostocontrolesiad,
  operacaopostomanutencao,
  operacaopostomigragestoresfrentista,
  operacaovazamento,
  operacaooperstatusterminais,
  operacaoprerecebimento,
  operacaoimpedimentos,
  operacaoradaprovarprefatura,
  operacaobloqueioprefaturageradaitem,
  operacaoliberacaoremotaconsulta,
  operacaoradpesquisaprefaturagfo,
  operacaoradpesquisaprefaturaunidata,
  operacaobloqueioveiculoprefaturas,
  cadastrousuariomaster,
  cadastrocondutor,
  cadastromarca,
  cadastroposto,
  cadastroterminal,
  operacaoradadmdadosfaturamentounidata,
  organRegistration,
  unityRegistration,
  vehicleRegistration,
  auditoria,
  auditoriaitem,

  bico,
  drawer,
  language,
  medidor,
  produto,
  comboio,
  dialog,
  posto,
  terminal,
  motorista,
  empresaveiculo,
  estoqueproduto,
  hooks,
  user,
  modeloveiculo,
  operacao,
  operacaoestoqueposto,
  operacaoestoquetanque,
  operacaorecebimento,
  operacaobloqueioveiculoprefaturagerada,
  operacaotransferencia,
  marcasveiculo,
  centrocusto,
  cercasvirtuais,
  contrato,
  usuario,
  veiculo,
  tanquevirtual,
  tanquefisico,
  arqueacao,
  configuracaoalarmetanque,
  operacaoafericaoveiculo,
  frentista,
  orgao,
  unidade,
  postoplanejamento,
  postoPlanejamentoGpp,

  operacaoradrelatoriopesquisaprefaturaunidata,
  operacaoradprefaturabloqueioplacarelatorio,
  operacaoveiculomanutencaounidata,
  rateio,
  pleitoposto,
  pleitoveiculo,
  operacaocotadistriborgao,
  operacaocotadistribunidade,
  operacaocotadistribveiculo,
  pleitoPostoAnexo,
  limiteAbastecimento,
  turnoAcompanhamento,
});
